import { render, staticRenderFns } from "./mobileLegalDocuments.vue?vue&type=template&id=55661d7b&scoped=true&"
import script from "./mobileLegalDocuments.vue?vue&type=script&lang=js&"
export * from "./mobileLegalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./mobileLegalDocuments.vue?vue&type=style&index=0&id=55661d7b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55661d7b",
  null
  
)

export default component.exports